import { t } from '@lingui/core/macro';
import { z } from 'zod';

import { TAX_ID_PATTERN } from '@/utils/validation';

export const createPracticeConfigurationSchema = () =>
  z.object({
    taxIdentificationNumber: z
      .string()
      .min(1, t`Tax Identification Number is required`)
      .regex(
        TAX_ID_PATTERN,
        t`Tax Identification Number must be 9 digits (e.g. 68-0663985 or 270728558)`,
      ),
    nationalProviderId: z.string().min(1, t`National Provider ID is required`),
    address1: z.string().min(1, t`Address is required`),
    address2: z.string(),
    city: z.string().min(1, t`City is required`),
    state: z.string().min(1, t`State is required`),
    zipcode: z
      .string()
      .min(1, t`Zipcode is required`)
      .regex(/^\d{5}$/, t`Zipcode must be exactly 5 digits`),
  });

export type PracticeConfigurationFormValues = z.infer<
  ReturnType<typeof createPracticeConfigurationSchema>
>;
